import * as pdfjsLib from "pdfjs-dist";
// Bundled locally per the CSP (no CDN worker): Vite copies this to its own
// hashed asset and gives us a same-origin URL.
import workerUrl from "pdfjs-dist/build/pdf.worker.mjs?url";

pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;

export interface RenderedPage {
  document: pdfjsLib.PDFDocumentProxy;
  page: pdfjsLib.PDFPageProxy;
  viewport: pdfjsLib.PageViewport;
  canvas: HTMLCanvasElement;
}

export async function loadPdf(data: ArrayBuffer): Promise<pdfjsLib.PDFDocumentProxy> {
  const task = pdfjsLib.getDocument({ data });
  return task.promise;
}

/** Resolves a 0-based page index, allowing -1 for "last page" (matches the
 * backend's `meta.page` convention). */
export function resolvePageIndex(pageIndex: number, pageCount: number): number {
  return pageIndex < 0 ? pageCount + pageIndex : pageIndex;
}

export async function renderPage(
  document: pdfjsLib.PDFDocumentProxy,
  pageIndex: number,
  canvas: HTMLCanvasElement,
  scale = 1.5,
): Promise<RenderedPage> {
  const resolvedIndex = resolvePageIndex(pageIndex, document.numPages);
  const page = await document.getPage(resolvedIndex + 1); // pdf.js pages are 1-based
  const viewport = page.getViewport({ scale });

  canvas.width = viewport.width;
  canvas.height = viewport.height;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("2D canvas context unavailable");

  await page.render({ canvasContext: ctx, viewport, canvas }).promise;
  return { document, page, viewport, canvas };
}
